


import React from "react";
import { currencyFormatNoDecimals } from "../../shared/shared";

export const Goals = (props) => {
    const financialDataItemTHStyle = {
        padding: "0.5em"
    };
    const financialDataItemTDStyle = {
        padding: "0.5em",
        fontSize: "0.9em",
        textAlign: "center"
    };
    const financialDataItemTRStyle = {
        borderBottom: "1p solid #ccc"
    }

    const subSectionStyle = { color: '#157ee8', margin: '25px 0', fontSize: "1em" }


    return (
        < div >
            <h2 style={subSectionStyle}>Goals</h2>
            <table style={{
                width: "100%",
                borderCollapse: "collapse"
            }}>
                <thead>
                    <tr style={{
                        backgroundColor: "#157ee8",
                        color: "white",
                    }}>
                        <th style={financialDataItemTHStyle}>Frequency</th>
                        <th style={financialDataItemTHStyle}>Amount</th>
                        <th style={financialDataItemTHStyle}>Start Year</th>
                        <th style={financialDataItemTHStyle}>End Year</th>
                    </tr>
                </thead>
                <tbody>
                    {props?.goals?.length > 0 && (
                        props.goals.map((item, idx) => {

                            return <tr key={idx} style={financialDataItemTRStyle}>
                                <td style={financialDataItemTDStyle}>{item.frequency}</td>
                                <td style={financialDataItemTDStyle}>{currencyFormatNoDecimals(item.amount)}</td>
                                <td style={financialDataItemTDStyle}>{item.startYear}</td>
                                <td style={financialDataItemTDStyle}>{item.endYear}</td>
                            </tr>

                        }))}
                </tbody>
            </table>
        </div>)

}

